export default "__VITE_ASSET__DWDQHARL__"